import { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { AuthContext } from "../../../../common/middlewares/Auth";

const useGetHistoricalSurvey = ({ autoLoad = true } = {}) => {
  const [data, setData] = useState([]);
  const authContext = useContext(AuthContext);
  const { token } = authContext;


  const getData = useCallback(async ({ strEmail }) => {
    try {
      const res = await axios({
        method: "GET",
        baseURL: `${process.env.REACT_APP_PROTOCOL_BACKEND}://${process.env.REACT_APP_HOST_BACKEND}${process.env.REACT_APP_PORT_BACKEND}`,
        url: `${process.env.REACT_APP_API_GETHISTORICALSURVEY}`,
        params: { strEmail },
        headers: { token },
      });
      setData(res.data.data || []);
      return res.data.data || [];
    } catch (error) {
      if (!axios.isCancel(error)) {
        const msg = error.response?.data?.msg || error.message;
        toast.error(msg);
        setData([]);
        throw error;
      }
    }
  }, [token]);

  const getUniqueData = async ({ strEmail }) => {
    let query = await getData({
      strEmail,
    });

    return query;
  };


  const refreshGetData = useCallback(({ strEmail }) => {
    setData([]);
    return getData({ strEmail });
  }, [getData]);


  const clearData = useCallback(() => {
    setData([]);
  }, []);

  useEffect(() => {
    if (autoLoad) {
      refreshGetData({ strEmail: "..." });
    }
  }, [autoLoad, refreshGetData]);

  return { data, refreshGetData, clearData, getUniqueData };
};

export { useGetHistoricalSurvey };